import React, { useEffect, useState } from "react";
import styles from "./../styles.module.scss";
import { Button, FilterDropdown, TextInput } from "components";
import { useDispatch, useSelector } from "react-redux";
import { subCategoriesAction, classActivityAction } from "redux/actions";
import axios from "axios";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";
import {adminToken, internalSearch} from "../../../../helper";

export default function UserListBySession({ onClick, details, session_id, setDetails }) {
  const dispatch = useDispatch();
  const classActivity = useSelector(state => state.classActivity)
  const [spLoader, setSpLoader] = useState(false);
  const [Userlist, setUserlist] = useState([])
  const {userRole} = useSelector(state => ({
      userRole: state.userRole?.filter(role => role.module === "Service Provider")
  }));


  useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read")) {
            dispatch(classActivityAction.get());
            setUserlist(classActivity?.filter(user => user.session_id == session_id))
        }
    }, []);
  
    

  return (
    <div className={styles.main__container}>
        <lable style={{"position": "absolute", "top": "10px", "left": "25px"}}>Enrolled Users ({Userlist?.length}) </lable>
        <table width="100%" className="table">
            <thead>
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Gender</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {
                Userlist?.map((user) => (
                    <tr>
                        <td>{user.user_id}</td>
                        <td>{user.user_name}</td>
                        <td>{user.mobile}</td>
                        <td>{user.email}</td>
                        <td>{user.gender}</td>
                        <td><a href={`${AWS_SERVER_APIS}/send-single-invite?email=${user.email}&name=${user.user_name}&class_name=${user.pkg_name}&class_date=${user.class_date}&class_time=${user.class_time}&class_link=${user.join_url}`} target="_blank">Mail</a></td>
                    </tr>
                ))
            }
            {(Userlist?.length < 1)?<tr><td colSpan={6}><center>User Not Enrolled</center></td></tr>:''}
            </tbody>
        </table>
    </div>
  );
}
